export default {
  // websocket地址
  websocketUrl: 'ws://127.0.0.1:50018',
  secret: 'FFFFFFFFFFFFFFFFFFFF',
  // 系统码
  // sysCode: '36363636',
  // 锁匠码
  // regCode: '31313131',
  // 操作后是否声音提示
  // beepAfterOperations: true,
  // //读取数据后是否清空
  clearAfterRead: true,
};
